import { cliengoQueries } from '@cliengo/mfe-utils/hooks';

import { useNavigationContext } from './Navigation';
import { NavigationItemsList } from './components/NavigationItemsList';
import { NavItems } from './components/NavItems';
import { NavBarContainer } from './components/NavbarContainer';

export const NavBar = () => {
  const { isSmall } = useNavigationContext();
  const { data: account } = cliengoQueries.account();

  if (isSmall || !account) {
    return null;
  }

  return (
    <NavBarContainer>
      <NavigationItemsList>
        <NavItems account={account} />
      </NavigationItemsList>
    </NavBarContainer>
  );
};
